import React from 'react'
import Image from '../../../images/buyerpolicies/Copyright.png'

const Copyright = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Copyright</h2>
            <p>Unless it has not been mentioned, the entire content available on this website is owned by KAAY. It is not allowed to use, tailor, republish, customize or publicize at any cost. You can definitely ask for authorization to use certain products such as images etc. You can contact us for permission at <a href='mailto:info@kaay.pk'>info@kaay.pk</a></p>
        </div>
      </div>
    </div>
  )
}

export default Copyright
